import type { Store } from '@reduxjs/toolkit';
import React from 'react';
import { Provider, useSelector } from 'react-redux';

type Props = {
  children: React.ReactNode;
  store: Store;
};

export const ReduxStoreProvider = ({ children, store }: Props) => {
  return <Provider store={store}>{children}</Provider>;
};

export const useStoreSelector = useSelector;
